import { render, staticRenderFns } from "./header-trigger.vue?vue&type=template&id=97a642e0&scoped=true&"
import script from "./header-trigger.vue?vue&type=script&lang=js&"
export * from "./header-trigger.vue?vue&type=script&lang=js&"
import style0 from "./header-trigger.vue?vue&type=style&index=0&id=97a642e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a642e0",
  null
  
)

export default component.exports